<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epigraph">
<p class="ct"><a class="xref" href="#/ppptenlords005#toc">Epigraph</a></p>
<p class="epf">Oh! glory of youth! consolation of age!</p>
<p class="ep">Sublimest of ecstasies under the sun;</p>
<p class="ep">Though the veteran may linger too long on the stage,</p>
<p class="ep">Yet he’ll drink a last toast to a fox-hunting run.</p>
<p class="ep">And oh! young descendants of ancient top-sawyers!</p>
<p class="ep">By your lives to the world their example enforce;</p>
<p class="ep">Whether landlords, or parsons, or statesmen, or lawyers,</p>
<p class="ep">Ride straight as they rode it from Ranksboro’ Gorse.</p>
<p class="epl">From ‘The Dream of the Old Meltonian’</p>
<p class="ept">W. Bromley Davenport</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-tenlords006.vue?3ef0f243